/** Offline breadth-first certified3×3 permutations. Keys are exact shortest
 * distances from123456780; runtime does no search. Tests independently verify. */
export const TIMED_POCKET_CATALOG = {
  6: [
    '152483076',
    '152483760',
    '052143786',
    '152743086',
    '150432786',
    '412753086',
    '412503786',
    '413725086',
    '413205786',
    '135426780',
    '023185476',
    '123805476',
    '120483765',
    '123408765',
    '230145786',
    '123705846',
    '123745860',
    '413726058',
    '413206758',
    '136402758',
    '243106758',
    '230146758',
    '123706548',
    '162403758',
    '012463758',
    '123468075',
    '253106478',
    '230156478',
    '130526478',
    '123576048',
    '123576480',
    '120563478',
  ],
  12: [
    '582173046',
    '412758063',
    '523184760',
    '410325786',
    '120473856',
    '120483576',
    '743105826',
    '435281760',
    '345106728',
    '035148762',
    '235106487',
    '013826457',
    '412863750',
    '023845176',
    '035216748',
    '713256840',
    '712403865',
    '041723586',
    '061423758',
    '130286475',
    '362148750',
    '264153780',
    '236704518',
    '013728564',
    '123574860',
    '162748035',
    '263178450',
    '275103486',
    '230158467',
    '236415780',
    '136208547',
    '162538047',
  ],
  18: [
    '872543016',
    '850172643',
    '514762830',
    '032516784',
    '150782364',
    '126407835',
    '541672083',
    '173285460',
    '183467250',
    '356408172',
    '135724068',
    '058236147',
    '130867452',
    '423615870',
    '083426157',
    '056238174',
    '071263854',
    '072416853',
    '713648520',
    '620451783',
    '382176450',
    '362715084',
    '124768035',
    '213786540',
    '710583624',
    '623415780',
    '023147568',
    '185637420',
    '238451760',
    '267183045',
    '216538470',
    '018526437',
  ],
  20: [
    '870542163',
    '826105473',
    '480152763',
    '731526084',
    '042156378',
    '874302516',
    '473501826',
    '524316078',
    '421857630',
    '810426753',
    '015637428',
    '572304816',
    '273415680',
    '250463187',
    '348705216',
    '081234765',
    '715203864',
    '753286140',
    '230814657',
    '437501862',
    '437618250',
    '468701523',
    '364517082',
    '624103785',
    '018764532',
    '072436158',
    '716408532',
    '723685140',
    '053246871',
    '280567134',
    '830126547',
    '160842537',
  ],
  22: [
    '847502163',
    '650132847',
    '520643187',
    '542801736',
    '315624780',
    '761352048',
    '027483516',
    '460832517',
    '420186357',
    '463172085',
    '028641753',
    '035768142',
    '032658174',
    '250437861',
    '137865024',
    '025486713',
    '463217085',
    '625378140',
    '287463150',
    '217683054',
    '326478510',
    '643785120',
    '670412538',
    '760384152',
    '286105374',
    '036725418',
    '130574628',
    '328671450',
    '143605827',
    '328561047',
    '251704683',
    '270538416',
  ],
  24: [
    '847562013',
    '067215843',
    '457612830',
    '068452137',
    '538462170',
    '145827036',
    '210756384',
    '317462085',
    '530742618',
    '064571823',
    '457321860',
    '250846317',
    '471306285',
    '820354716',
    '730864215',
    '078531246',
    '067153824',
    '738641052',
    '614235870',
    '821354760',
    '316807524',
    '327486051',
    '045617283',
    '682301754',
    '342567018',
    '654107823',
    '768524031',
    '063284517',
    '687312045',
    '265814730',
    '027146385',
    '517468023',
  ],
  26: [
    '047862513',
    '534708126',
    '530164872',
    '845632710',
    '324518760',
    '863574012',
    '564817032',
    '840217635',
    '210546387',
    '841207536',
    '632478051',
    '648503127',
    '576842031',
    '483607152',
    '865104237',
    '480352167',
    '758631420',
    '837456120',
    '837561240',
    '084156372',
    '287604513',
    '514607238',
    '876251034',
    '537648210',
    '240876315',
    '680452371',
    '670354182',
    '074218365',
    '647203581',
    '028675341',
    '057438621',
    '257301648',
  ],
  28: [
    '847623510',
    '821534067',
    '867401352',
    '061875324',
    '178653240',
    '647851032',
    '580627341',
    '530642817',
    '340587621',
    '576831420',
    '475683210',
    '021647385',
    '867432051',
    '487521360',
    '047628351',
    '583641720',
    '317684520',
    '470185236',
    '370852614',
    '170248365',
    '683571420',
    '024317685',
    '851247360',
    '067412385',
    '037648251',
    '140287365',
    '870426135',
    '657184023',
    '064837251',
    '062871354',
    '658271034',
    '758264031',
  ],
};
